import { render, staticRenderFns } from "./TransferFunds.vue?vue&type=template&id=4760373a&scoped=true"
import script from "./TransferFunds.vue?vue&type=script&lang=ts"
export * from "./TransferFunds.vue?vue&type=script&lang=ts"
import style0 from "./TransferFunds.vue?vue&type=style&index=0&id=4760373a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4760373a",
  null
  
)

export default component.exports